import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';
import GlobalSearchBar from './GlobalSearchBar';

const NavigationHeader = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleLogoClick = () => {
    navigate('/client-dashboard');
  };

  const handleAddClient = () => {
    navigate('/add-new-client');
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-card border-b border-border shadow-sm">
      <div className="flex items-center justify-between h-16 px-6">
        {/* Logo Section */}
        <div 
          className="flex items-center cursor-pointer transition-opacity duration-150 hover:opacity-80"
          onClick={handleLogoClick}
        >
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="Sun" size={20} color="white" />
            </div>
            <div className="hidden sm:block">
              <h1 className="text-xl font-semibold text-foreground">
                Solarium Manager
              </h1>
            </div>
          </div>
        </div>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-6 flex-1 max-w-2xl mx-8">
          <GlobalSearchBar />
        </div>

        {/* Desktop Actions */}
        <div className="hidden md:flex items-center space-x-4">
          <Button
            variant={isActive('/client-dashboard') ? 'default' : 'ghost'}
            onClick={() => navigate('/client-dashboard')}
            iconName="LayoutDashboard"
            iconPosition="left"
            iconSize={18}
            className="transition-all duration-150"
          >
            Dashboard
          </Button>
          <Button
            variant="default"
            onClick={handleAddClient}
            iconName="UserPlus"
            iconPosition="left"
            iconSize={18}
            className="bg-primary hover:bg-primary/90 text-primary-foreground transition-all duration-200 hover:shadow-md"
          >
            Add Client
          </Button>
          {(() => {
            try {
              const token = localStorage.getItem('auth_token');
              if (!token) return null;
              const payload = JSON.parse(atob(token.split('.')[1]));
              if (payload.role === 'admin') {
                return (
                  <>
                    <Button
                      variant={isActive('/admin') ? 'default' : 'ghost'}
                      onClick={() => navigate('/admin')}
                      iconName="Shield"
                      iconPosition="left"
                      iconSize={18}
                      className="transition-all duration-150"
                    >
                      Admin
                    </Button>
                  </>
                );
              }
            } catch {}
            return null;
          })()}
          <Button
            variant="ghost"
            onClick={() => {
            localStorage.removeItem('auth_token');
            window.location.reload();
            }}
            iconName="LogOut"
            iconPosition="left"
            iconSize={18}
            className="transition-all duration-150"
        >
            Logout
        </Button>
        </div>

        {/* Mobile Menu Button */}
        <div className="md:hidden">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            iconName={isMenuOpen ? "X" : "Menu"}
            iconSize={20}
            className="transition-transform duration-150"
          />
        </div>
      </div>

      {/* Mobile Search Bar */}
      <div className="md:hidden px-6 pb-4 border-b border-border">
        <GlobalSearchBar />
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-card border-b border-border shadow-lg animate-slide-in">
          <div className="px-6 py-4 space-y-3">
            <Button
              variant={isActive('/client-dashboard') ? 'default' : 'ghost'}
              onClick={() => {
                navigate('/client-dashboard');
                setIsMenuOpen(false);
              }}
              iconName="LayoutDashboard"
              iconPosition="left"
              iconSize={18}
              fullWidth
              className="justify-start transition-all duration-150"
            >
              Dashboard
            </Button>
            
            <Button
              variant="default"
              onClick={() => {
                handleAddClient();
                setIsMenuOpen(false);
              }}
              iconName="UserPlus"
              iconPosition="left"
              iconSize={18}
              fullWidth
              className="justify-start bg-primary hover:bg-primary/90 text-primary-foreground transition-all duration-200"
            >
              Add Client
            </Button>
            {(() => {
            try {
              const token = localStorage.getItem('auth_token');
              if (!token) return null;
              const payload = JSON.parse(atob(token.split('.')[1]));
              if (payload.role === 'admin') {
                return (
                  <>
                    <Button
                      variant={isActive('/admin') ? 'default' : 'ghost'}
                      onClick={() => navigate('/admin')}
                      iconName="Shield"
                      iconPosition="left"
                      iconSize={18}
                      className="transition-all duration-150"
                    >
                      Admin
                    </Button>
                  </>
                );
              }
            } catch {}
            return null;
          })()}
          <Button
            variant="ghost"
            onClick={() => {
            localStorage.removeItem('auth_token');
            window.location.reload();
            }}
            iconName="LogOut"
            iconPosition="left"
            iconSize={18}
            className="transition-all duration-150"
        >
            Logout
        </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default NavigationHeader;